import { jsx } from 'react/jsx-runtime';
import { PermissionContext } from './context.js';

const PermissionProvider = ({ loading, plugins = [], authenticated = false, roles = [], children })=>{
    return jsx(PermissionContext.Provider, {
        value: {
            loading,
            authenticated,
            plugins,
            roles
        },
        children: children
    });
};

export { PermissionProvider };
//# sourceMappingURL=provider.js.map
